export default __webpack_public_path__ + "static/media/Series-X-3.f77241fb.jpg";